import { render, staticRenderFns } from "./modifier-group-translation-form.vue?vue&type=template&id=e45587be"
import script from "./modifier-group-translation-form.vue?vue&type=script&lang=js"
export * from "./modifier-group-translation-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports